import { useEffect, useState } from 'react';

/**
 * Debounce sebuah value. Output lag sebesar delayMs dari input.
 * Berguna untuk real-time check seperti check-id perusahaan.
 */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
